import { type GetServerSideProps } from 'next'

import { getCatalog } from '@services/catalog'
import { Register } from '@components/Register/RegisterForm'

const RegisterPage = () => {
  return <Register />
}

export default RegisterPage

export const getServerSideProps: GetServerSideProps = async () => {
  try {
    const [documentTypesCatalog, sexsCatalog] = await Promise.all([
      getCatalog('documentTypes'),
      getCatalog('genders')
    ])

    return {
      props: {
        catalog: {
          documentTypesCatalog: documentTypesCatalog ?? [],
          sexsCatalog: sexsCatalog ?? []
        }
      }
    }
  } catch (error) {
    return {
      props: {
        catalog: {
          documentTypesCatalog: [],
          sexsCatalog: []
        }
      }
    }
  }
}
